<template>
  <div class="switcher-wrapper">
    <div class="switcher-item">
      <input
        id="radio-group-user-1"
        v-model="dataModelChecked"
        :value="ID_ROLE_OPERATOR"
        type="radio"
        name="radio-group-user">
      <label for="radio-group-user-1">Operator</label>
    </div>
    <div class="switcher-item">
      <input
        id="radio-group-user-2"
        v-model="dataModelChecked"
        :value="ID_ROLE_TEAM_LEADER"
        type="radio"
        name="radio-group-user">
      <label for="radio-group-user-2">Team Leader</label>
    </div>
  </div>
</template>

<script>
import { ID_ROLE_OPERATOR, ID_ROLE_TEAM_LEADER } from '../../service/consts';

export default {
  name: 'CallCheckedGroup',
  props: {
    value: {
      type: String,
      default: ID_ROLE_OPERATOR
    }
  },
  data () {
    return {
      dataModelChecked: this.value
    };
  },
  computed: {
    ID_ROLE_OPERATOR: () => ID_ROLE_OPERATOR,
    ID_ROLE_TEAM_LEADER: () => ID_ROLE_TEAM_LEADER
  },
  watch: {
    dataModelChecked () {
      this.$emit('input', this.dataModelChecked);
    },
    value () {
      this.dataModelChecked = this.value;
    }
  }
};
</script>
